import { render, staticRenderFns } from "./genres.vue?vue&type=template&id=61e31555&scoped=true&"
import script from "./genres.vue?vue&type=script&lang=js&"
export * from "./genres.vue?vue&type=script&lang=js&"
import style0 from "./genres.vue?vue&type=style&index=0&id=61e31555&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e31555",
  null
  
)

export default component.exports